module.exports = "../fonts/blue_phone_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blue_phone_icon.svg
// module id = 118
// module chunks = 0